import React, { useState } from 'react';
import { Card, Button, Form, Alert, Input, Row, Col, Switch } from 'antd';
import SetupCard from './SetupCard';
import { useTranslation } from 'react-i18next';

export default function SetupSmtp({
  initialValues,
  step,
  pending,
  pendingCheck,
  checkEmail,
  onChange,
  onCancel,
  onDone,
}) {
  const [form] = Form.useForm();
  const [email, setEmail] = useState('');
  const [help, setHelp] = useState(false);
  const { t } = useTranslation();

  const handleDone = () => {
    onDone(form.getFieldsValue());
  };

  const handleCheck = () => {
    if (email) {
      checkEmail({ email }, () => setHelp(true));
    }
  };

  return (
    <SetupCard
      step={step}
      pending={pending}
      onCancel={onCancel}
      onDone={handleDone}
    >
      <Form
        form={form}
        initialValues={initialValues}
        layout="vertical"
        name="setup-smtp-form"
        onValuesChange={onChange}
      >
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item name="url" label={t('setup-smtp-url')}>
              <Input autoComplete={false} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="port" label={t('setup-smtp-port')}>
              <Input autoComplete={false} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item name="login" label={t('setup-smtp-login')}>
              <Input autoComplete={false} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="password" label={t('setup-smtp-password')}>
              <Input autoComplete={false} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="ssl">
          <Switch /> {t('setup-smtp-ssl')}
        </Form.Item>
      </Form>
      <Form layout="vertical" name="setup-smtp-form-check">
        <Card className="setup-smtp-form__check">
          <Row gutter={12}>
            <Col flex="auto">
              <Input
                size="small"
                placeholder={t('setup-smtp-test-placeholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Col>
            <Col flex="215px">
              <Button
                size="small"
                type="primary"
                block
                loading={pendingCheck}
                onClick={handleCheck}
              >
                {t('setup-smtp-test-send')}
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>
      {help ? (
        <Alert message={t('setup-smtp-test-help')} type="warning" showIcon />
      ) : null}
    </SetupCard>
  );
}
